import { Injectable } from '@angular/core';
import { MenuNivel } from 'src/app/model/MenuNivel';

// USER
const USER = 'user';
const USER_ID = 'user_id';
const TOKEN = 'token';
const PERMIT = 'permit';

// Parameters
const ANO_LETIVO = 'ano';
const LISTA_PRECO = 'lista';
const LISTA_PRECO_PUBLICO = 'lista-publico';
const INICIO_VENDA = 'inicio-venda';
const FIM_VENDA = 'fim-venda';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() { }

  public clean(): void {
    window.sessionStorage.clear();
  }

  public saveUserSession(user: any, token: any, permit: any) {
    // user
    window.sessionStorage.removeItem(USER);
    window.sessionStorage.setItem(USER, btoa(user.nome));

    // user_id
    window.sessionStorage.removeItem(USER_ID);
    window.sessionStorage.setItem(USER_ID, btoa(user.id_usuario));

    // token
    window.sessionStorage.removeItem(TOKEN);
    window.sessionStorage.setItem(TOKEN, token);

    // permissoes
    window.sessionStorage.removeItem(PERMIT);
    window.sessionStorage.setItem(PERMIT, JSON.stringify(permit));
  }

  public saveAnoLetivo(ano_letivo: any) {
    window.sessionStorage.removeItem(ANO_LETIVO);
    window.sessionStorage.setItem(ANO_LETIVO, ano_letivo);
  }

  public saveParameterSession(
    listaPreco: any,
    listaPrecoPublico: any,
    inicioVenda: any,
    fimVenda: any
  ) {
    window.sessionStorage.removeItem(LISTA_PRECO);
    window.sessionStorage.setItem(LISTA_PRECO, listaPreco);

    window.sessionStorage.removeItem(LISTA_PRECO_PUBLICO);
    window.sessionStorage.setItem(LISTA_PRECO_PUBLICO, listaPrecoPublico);

    window.sessionStorage.removeItem(INICIO_VENDA);
    window.sessionStorage.setItem(INICIO_VENDA, inicioVenda);

    window.sessionStorage.removeItem(FIM_VENDA);
    window.sessionStorage.setItem(FIM_VENDA, fimVenda);
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return atob(user);
    }
    return {};
  }

  public getUserId(): any {
    const user_id = window.sessionStorage.getItem(USER_ID);
    if (user_id) {
      return atob(user_id);
    }
    return {};
  }

  public getToken(): any {
    const value = window.sessionStorage.getItem(TOKEN);
    if (value) return value;

    return '';
  }

  public getPermissoes(): any {
    const value = window.sessionStorage.getItem(PERMIT);
    if (value)
      return JSON.parse(value);

    return '';
  }

  public getParameters(): any {
    const ano_letivo = window.sessionStorage.getItem(ANO_LETIVO);
    const lista_preco = window.sessionStorage.getItem(LISTA_PRECO);
    const lista_preco_publico =
      window.sessionStorage.getItem(LISTA_PRECO_PUBLICO);
    const inicio_venda = window.sessionStorage.getItem(INICIO_VENDA);
    const fim_venda = window.sessionStorage.getItem(FIM_VENDA);

    const parametros = {
      ano_letivo: ano_letivo,
      lista_preco: lista_preco,
      lista_preco_publico: lista_preco_publico,
      inicio_venda: inicio_venda,
      fim_venda: fim_venda,
    };

    if (parametros) return parametros;

    return {};
  }

  public isloggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return true;
    }
    return false;
  }

  public temAcessoMenu(menu: number): boolean {
    var permissoes: MenuNivel[] = this.getPermissoes();

    var ret = false;

    for (let i = 0; i < permissoes.length; i++) {
      var p = permissoes[i];

      if (p.id_menu == menu) {
        ret = true;
      }
    }

    return ret;
  }
}
